import React, { useState, useEffect, useRef } from 'react';
import styles from './index.module.scss';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import EcoImg from 'eco-design/base/eco-img';
import EcoButton from 'eco-design/base/eco-button';
import { productSeriesConf } from './productData';
import { getMemberListProducts } from '@/service/vip';
import { useGlobal } from '@/utils/useGlobal';
import { Navigation, Scrollbar, Pagination, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import getLocal from '@/app/utils/i18n';

const UsageScenarios: React.FC = () => {
    const { t } = useLang('Delta3AirStation.UsageScenarios');
    const { useRouter, isMobile } = useGlobal();
    const [initStatus, setInitStatus] = useState<boolean>(false);
    const { locale } = useRouter();
    const getVids = () => productSeriesConf[locale]?.map((item) => item.variantId);
    const swiperRef = useRef<any>(null);

    const contentList: any = [
        {
            key: 'a',
            bgPc: 'https://websiteoss.ecoflow.com/upload/image/1761829888530/11.jpg',
            bgH5: 'https://websiteoss.ecoflow.com/upload/image/1761830046428/Frame%202094654483.jpg',
            prod: [
                {
                    variantId: '52322583970159',
                    title: '',
                    desc: t('prod_1_desc'),
                    prodImg: '',
                },
            ],
        },
        {
            key: 'b',
            bgPc: 'https://websiteoss.ecoflow.com/upload/image/1761829888684/22.jpg',
            bgH5: 'https://websiteoss.ecoflow.com/upload/image/1761830046256/Frame%202094654482.jpg',
            prod: [
                {
                    title: '',
                    desc: t('prod_2_desc'),
                    variantId: '52322658713967',
                    prodImg: '',
                },
                {
                    title: '',
                    desc: t('prod_3_desc'),
                    variantId: '52261686018415',
                    prodImg: '',
                },
            ],
        },
        {
            key: 'c',
            bgPc: 'https://websiteoss.ecoflow.com/upload/image/1761829888879/33.jpg',
            bgH5: 'https://websiteoss.ecoflow.com/upload/image/1761830046076/Frame%201000007601.jpg',
            prod: [
                {
                    title: '',
                    desc: t('prod_4_desc'),
                    variantId: '52261686051183',
                    prodImg: '',
                },
            ],
        },
    ];

    const handlePushGtm = (product: string, url: string) => {
        saveCookieForShopify(url, locale);
    };

    const [productList, setProductList] = useState<any>(contentList);

    const items = [
        {
            tabLabel: t('tab_1'),
            tabValue: 'a',
        },
        {
            tabLabel: t('tab_2'),
            tabValue: 'b',
        },
        {
            tabLabel: t('tab_3'),
            tabValue: 'c',
        },
    ];

    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        swiperRef.current?.slideTo(index);
        swiperRef.current.updateAutoHeight(300);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('title'),
            button_name: items[index].tabLabel,
        });
    };

    const getProductData = () => {
        if (!getVids()) return;

        try {
            getMemberListProducts(
                {
                    variantIds: getVids(),
                },
                locale,
            ).then((res) => {
                if (res?.code === '0' && res.data) {
                    contentList.forEach((item: any) => {
                        item.prod.forEach((itemProd: any) => {
                            const findItem = res.data.find((v: any) => v.variantId === itemProd.variantId) || {};
                            itemProd.title = findItem.skuTitle;
                            itemProd.prodImg = findItem.variantImg;
                        });
                    });

                    setProductList([...contentList]);
                    setTimeout(() => {
                        swiperRef.current.updateAutoHeight(300);
                    }, 10);
                }
            });
        } catch (error) {
            console.log('error->>', error);
        }
    };

    useEffect(() => {
        getProductData();
    }, []);

    return (
        <section className={`${styles.UsageScenarios} GtmModuleData-section`} data-section-id="UsageScenarios">
            <div className="scenarios-bg">
                <div className="title">{t('title')}</div>
                <div className="tabs">
                    <EcoTab type="square" onChange={toggleItemHandle} items={items} theme={'white'} />
                </div>
                {
                    <Swiper
                        modules={[Navigation, EffectFade]}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        effect={'fade'}
                        speed={800}
                        centeredSlides={true}
                        slidesPerView={'auto'}
                        autoHeight={true} // ✅ 关键点：自动匹配当前slide高度
                        allowTouchMove={false} // 🚫 禁止触摸滑动
                        simulateTouch={false} // 🚫 禁止鼠标拖动
                        keyboard={{ enabled: false }} // 🚫 禁止键盘操作
                        mousewheel={false} // 🚫 禁止滚轮操作
                    >
                        {productList.map((item: any, index: number) => (
                            <SwiperSlide key={index} className="swiper-slide">
                                <div className="usage-content">
                                    <div className="usage-bg">
                                        <EcoImg alt={t('title')} pc={item.bgPc} pad={item.bgH5} h5={item.bgH5} isOpenLazy></EcoImg>
                                    </div>
                                    <div className={`usage-product product-usage-${item.prod.length}`}>
                                        {item.prod.map((v: any, i: number) => (
                                            <div className="product-item" key={i}>
                                                <div className="left-prod">
                                                    <EcoImg pc={v.prodImg} alt={v.title}></EcoImg>
                                                </div>
                                                <div className="right-content">
                                                    <div className="right-top">
                                                        <div className="right-title">{v.title}</div>
                                                        <div className="right-desc">{v.desc}</div>
                                                    </div>
                                                    <EcoButton
                                                        lType="filled"
                                                        className={`buy-btn GtmModuleData-btn-href __btn_d3a_${index}`}
                                                        lHref={`https://${locale}.ecoflow.com/products/delta-3-1000-air-portable-power-station`}
                                                        lDataLayer={{
                                                            event: 'uaEvent',
                                                            event_name: 'buy',
                                                            product_name: v.title,
                                                            position: t('title'),
                                                            __btn_id1: `__btn_d3a_${index}`,
                                                            __btn_type: 'href',
                                                            __btn_id2: `https://${locale}.ecoflow.com/products/delta-3-1000-air-portable-power-station`,
                                                        }}
                                                        onClick={() =>
                                                            handlePushGtm(
                                                                v.title,
                                                                `https://${locale}.ecoflow.com/products/delta-3-1000-air-portable-power-station`,
                                                            )
                                                        }
                                                    >
                                                        {t('btn_name')}
                                                    </EcoButton>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                }
            </div>
        </section>
    );
};

export default UsageScenarios;
